export const formatBrlToNumber = (value: string): number => {
    if (!value || value === "NaN") {
        return 0;
    }

    const parsed = Number(value.replace(/\./g, "").replace(",", "."));

    return Number.isFinite(parsed) ? parsed : 0;
};
